import React from "react";

const Terms = () => {
  return (
    <main style={{ textAlign: "left" }}>
      <section
        style={{
          paddingBottom: "1.5rem",
          background: "white",
          backgroundColor: "white",
          lineHeight: "1.75rem",
        }}
      >
        <div
          style={{
            margin: "0 auto",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            maxWidth: "944px",
          }}
        >
          <h1
            style={{
              textAlign: "center",
              fontSize: "1.875rem",
              fontWeight: "bold",
              marginBottom: "0.25rem",
              marginTop: "0.25rem",
            }}
          >
            Terms & Conditions
          </h1>
          <h3
            style={{
              fontSize: "1.125rem",
              marginBottom: "3.25rem",
              textAlign: "center",
            }}
          >
            Updated on: 8/26/26 (prior versions and their effective dates are
            archived and available upon request).
          </h3>
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              marginBottom: "0.25rem",
            }}
          >
            INTRODUCTION
          </h2>
          <p style={{ marginBottom: "0.5rem" }}>
            Welcome to Trusted Therapist Network, the networking and referral
            platform for mental health services. By registering as a Trusted
            Therapist Network member or otherwise accessing or using any of our
            websites or mobile applications, including any and all related
            services (collectively, the "Services"), you are entering into a
            legally binding contract with Phoenix Relational LLC d/b/a Trusted
            Therapist Network ("Trusted Therapist Network," "we," "us," or
            "our"). The following Terms of Services (these "Terms") govern your
            access to and use of the Services.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>For purposes of these Terms:</p>
          <ul style={{ marginBottom: "0.5rem", paddingLeft: "3.5rem" }}>
            <li style={{ marginBottom: "0.25rem" }}>
              A "Member" is any individual or entity that registers for or uses
              the Services, whether or not they pay a fee.
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              A "Client" is any Member that purchases a paid subscription to the
              Services (a "Subscription").
            </li>
          </ul>
          <p style={{ marginBottom: "0.5rem" }}>
            <b>These Terms apply to all Members.</b> The sections titled "Fees,"
            "Billing Subscriptions," "Manner of Payment," "Timing of Payment,"
            "Discounts," "No Early Termination; No Refunds," "Suspension for
            Non-Payment," and "Termination for Cause" apply only to Clients with
            an active paid Subscription.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            THE SERVICE IS NOT INTENDED TO BE USED FOR THE EXCHANGE OF PROTECTED
            HEALTH INFORMATION ("PHI"). THESE TERMS DO NOT CONSTITUTE A BUSINESS
            ASSOCIATE AGREEMENT WITH PHOENIX RELATIONAL LLC. YOU ARE RESPONSIBLE
            FOR UNDERSTANDING WHAT CONSTITUTES PROTECTED HEALTH INFORMATION.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            As a social network and professional resource, we will receive,
            store and process personal information about you and other Trusted
            Therapist Network members. Processing this information is essential
            to the Services that we provide and a necessary part of our
            performance of our agreement with you.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            By accessing the Services, you acknowledge that you have read,
            understand, and attest to the following statement:
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            "I am ethically required to make appropriate referrals on occasion. I use Trusted Therapist Network's online directory to access other mental health providers. I attempt to match patient needs to participants who have listed specific skills and openings and I make referrals on that basis. The platform may, in its sole discretion, periodically check whether participants have regulatory issues, licensure-related issues, exclusion from certain federal health care programs, or any past, present, or pending disciplinary action, complaint, investigation, sanction, restriction, limitation, probation, suspension, surrender, revocation, or other matter that could reflect on professional standing, and may deny, suspend, restrict, or remove participants from the platform based on such findings or concerns. I neither receive nor pay any fee for any particular referral."
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            <b>
              If you do not attest to the prior statement, do not access or use
              the Services.
            </b>{" "}
            By accessing the Services, you also acknowledge that you have read
            and understand these Terms, and that you agree to be bound by them.
            If you do not agree to be bound by these Terms, do not access or use
            the Services.
          </p>
          <br />
          <hr></hr>
          <p style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
            THE TRUSTED THERAPIST NETWORK SERVICES
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
            Eligibility
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            By accessing the Services, you agree you are currently 18 years of
            age or older and a licensed United States psychiatrist,
            psychologist, school psychologist, counselor, clinician, therapist,
            clinical social worker or other mental health practitioner or other
            professional that refers for mental health or substance abuse
            treatment or services. If you are not licensed you agree that you
            are currently and actively working under the direct supervision of a
            licensed clinician that is authorized to provide supervision by the
            state you reside in. You also agree that any information you provide
            to us in connection with your account registration is accurate and
            complete, and that Trusted Therapist Network may use such
            information to provide the Services.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Trusted Therapist Network reserves the right, in its sole discretion, to deny any registration or application for membership, deny access to the Services, suspend, restrict, or terminate any account, or remove any Member from the platform if Trusted Therapist Network becomes aware of, or reasonably suspects, any past, present, or pending disciplinary action, complaint, investigation, sanction, consent agreement, reprimand, probation, restriction, limitation, suspension, surrender, revocation, exclusion, or other licensure-related, regulatory, ethical, or professional conduct concern. Trusted Therapist Network shall have no obligation to permit or continue access to the Services while any such matter is pending review, investigation, appeal, or resolution, and may act based on its independent judgment to protect the integrity of the platform and its Members.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            If you are accepting these Terms on behalf of your employer or
            another entity, you represent and warrant that (i) you have full
            legal authority to bind your employer or such legal entity to these
            Terms, (ii) you have read and understand these Terms, and (iii) you
            agree, on behalf of the entity, to these Terms.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Trusted Therapist Network is a United States company. Your
            information is stored within the United States. The Services are
            designed specifically for mental health practitioners and
            professionals that refer for mental health services in the United
            States. We do not target users in other jurisdictions and we make no
            claims that the Services or any associated content is appropriate
            for users outside of the United States.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            You may use the Services only for lawful purposes and in accordance
            with these Terms. You agree not to use the Services:
          </p>
          <ul style={{ marginBottom: "0.5rem", paddingLeft: "3.5rem" }}>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                In any way that violates any federal, state or local law or
                regulation or professional rule applicable to you and your use
                of the Services including, without limitation, those relating to
                patient privacy, medical care and treatment, including the
                Health Insurance Portability and Accountability Act (HIPAA), the
                Physician Self-Referral Law (the Stark law), and/or the
                Telephone Consumer Protection Act (TCPA).
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                In any way that violates or conflicts with any agreement to
                which you are a party, including any agreement with your
                employer.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                To transmit any material that does not comply with the "Member
                Content Standards" outlined below.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                To impersonate another person, or misrepresent your identity or
                affiliation with any person or entity (e.g., by using an e-mail
                address, username or caller ID that misrepresents your
                affiliation).
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                In any manner that could disable, overburden, damage, or impair
                any component of the Services.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                To transmit any "junk mail" or "junk faxes," "bulk mail" or
                "bulk faxes," "chain letters," "spam," or any other similar
                solicitation.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                To repeatedly post the same or substantially similar promotional
                content, engage in excessive self-promotion, or use posts or
                comments in a manner that Trusted Therapist Network determines
                constitutes spam or interferes with the usefulness of the
                community.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                To engage in any other conduct that inhibits anyone's use or
                enjoyment of the Services or which, as determined by us, may
                harm Trusted Therapist Network or members of the Services.
              </p>
            </li>
          </ul>
          <p style={{ marginBottom: "0.5rem" }}>
            Additionally, you agree not to:
          </p>
          <ul style={{ marginBottom: "0.5rem", paddingLeft: "3.5rem" }}>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                <b>
                  PROVIDE, DISCLOSE, UPLOAD, MAKE AVAILABLE AND/OR SHARE IN ANY
                  MANNER PROTECTED HEALTH INFORMATION (PHI) OF YOUR PATIENTS
                  THROUGH THE SERVICE.
                </b>
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Re-use or re-publish any content posted or made available
                through the Services by another Trusted Therapist Network
                member, without providing appropriate attribution and credit to
                such other Trusted Therapist Network member.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Take credit for any content posted or made available by any
                other Trusted Therapist Network member.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Copy any of the material made available through the Services for
                commercial purposes, including through the scraping of content.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Attempt to obtain unauthorized access to or interfere with the
                Services, any Trusted Therapist Network computer system,
                software or network, including through reverse engineering,
                decompiling, deriving source code or uploading malicious code or
                code snippets.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Tamper with, breach or attempt to probe, scan, or test for
                vulnerabilities in the Services or Trusted Therapist Network's
                computer systems, network, security elements, or any other
                protective measures associated with the Services.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Use any software, devices, scripts, robots or any other means or
                process to view, access or "scrape" the Services or otherwise
                copy information from the Services, or to transmit any
                communications using the Services including, without limitation,
                faxes or member messages.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Reproduce or redistribute content provided through the Services,
                including through "framing" or "mirroring" or through third
                parties, without Trusted Therapist Network's consent.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Reverse engineer, decompile, disassemble, decipher or otherwise
                attempt to derive the source code for the Services or any
                related technology that is not open source, including, but not
                limited to, any competitive purpose.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Monitor the availability, performance or functionality of any of
                the Services for any competitive purpose.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Use the Service in order to report on the features, functions
                and capabilities of the Service to a competing company,
                organization or software product.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Deep-link to any of our websites (i.e., linking to a Trusted
                Therapist Network web page other than the Trusted Therapist
                Network home page) unless solely to promote your profile or
                practice on the Services, or as otherwise expressly approved by
                Trusted Therapist Network in writing on a case-by-case basis.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Infringe or use any of our brands, logos trademarks or other
                proprietary marks in any business name, e-mail, URL or other
                context, unless expressly approved by Trusted Therapist Network
                in writing.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Introduce into the Services any viruses, Trojan horses, worms,
                logic bombs, or other material that is malicious or
                technologically harmful.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Otherwise attempt to interfere with the proper working of the
                Services, or any portion thereof.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Use the Services to advertise, market, endorse, broker, or promote third-party vendors,
                products, or services (including, without limitation, practice management, billing, revenue cycle management, credentialing, marketing, consulting, lead generation, software, or staffing
                services), except as expressly authorized by Trusted Therapist Network in writing.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Use the Services to solicit, offer, request, arrange for, or receive any referral fee, commission,
                kickback, rebate, revenue share, affiliate compensation, or other direct or indirect remuneration
                in exchange for recommending, introducing, or steering Members or other persons to any third-
                party vendor, product, or service.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Use information obtained through the Services, including member identities, contact
                information, relationships, or activity, to build prospect lists for third-party vendors or to
                conduct off-platform sales, lead generation, or commercial solicitation.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Fail to clearly disclose any material financial interest, compensation arrangement, ownership
                interest, employment relationship, or other conflict of interest relating to any recommendation,
                mention, or discussion of a product, service, practice, or vendor on the Services.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Use the Services primarily to recruit Members into outside paid
                communities, referral networks, directories, membership
                organizations, or other services that substantially duplicate
                Trusted Therapist Network's core networking and referral
                functions.
              </p>
            </li>
          </ul>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Member Content Standards
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            You may submit content and other information to the Services
            ("Member Content") in a variety of ways, including through your
            profile, announcements, and any other communication tools we offer.
            You agree that you are solely responsible for your Member Content,
            including its legality, reliability, accuracy, and appropriateness,
            your Member Content complies with these Terms, and you have all
            rights in your Member Content as necessary to grant the license
            granted herein.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Trusted Therapist Network is designed to be a collaborative
            professional community where Members can build relationships,
            exchange referrals, share resources, and stay connected to the
            behavioral health community. To maintain a useful, relevant, and
            balanced community, Member Content is also subject to the following
            posting standards.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Referral Posts
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            There is no limit on referral-related posts. Members are encouraged
            to use Trusted Therapist Network to seek trusted referrals,
            recommend appropriate resources, identify levels of care, and
            connect clients with appropriate providers and treatment programs,
            provided such posts otherwise comply with these Terms, including the
            prohibition against sharing PHI.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Self-Promotional Content
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Members may share relevant information regarding their own
            practices, programs, professional services, events, trainings,
            resources, and professional opportunities. To maintain a balanced
            community feed, Members may post self-promotional content no more
            than one (1) time within any seven (7)-day period. Content exceeding
            this limit may be removed, and repeated violations may result in the
            posting, messaging, suspension, or termination remedies described in
            the "Community Moderation" and "Term and Termination" sections.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Self-promotional content may include, without limitation:
          </p>
          <ul style={{ marginBottom: "0.5rem", paddingLeft: "3.5rem" }}>
            <li style={{ marginBottom: "0.25rem" }}>
              Practice, program, or professional service announcements;
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              Events, workshops, webinars, trainings, or support groups;
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              Courses or consulting services;
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              Podcasts, newsletters, books, or other professional content; and
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              Professional groups, communities, or membership opportunities.
            </li>
          </ul>
          <p style={{ marginBottom: "0.5rem" }}>
            Repeatedly posting the same or substantially similar promotional
            content, including reposting or slightly modifying previously shared
            promotional content in an effort to circumvent the seven-day
            limitation, may be considered spam and may be removed.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Comments and Relevance
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Members are encouraged to engage with other Members' posts, make
            professional connections, and share information that is responsive
            and helpful. Comments should remain relevant to the topic, question,
            referral request, or other subject matter of the original post.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Members should not use comments on unrelated posts to promote their
            own practices, services, programs, events, groups, communities, or
            other offerings. Promotional content should instead be shared
            through the Member's own post and remains subject to the
            self-promotional posting limitations described above. Comments that
            violate this standard may be removed and may result in the
            moderation or enforcement actions described in the "Community
            Moderation" section.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Outside Groups, Events, and Communities
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Trusted Therapist Network recognizes that Members may participate in
            professional organizations, events, networking opportunities, and
            communities outside of the Services, and Members may share such
            resources when they are relevant and may provide meaningful value to
            the TTN community.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            However, the Services may not be used primarily to recruit Members
            for outside paid communities, referral networks, directories, or
            services that substantially duplicate Trusted Therapist Network's
            core networking and referral functions, whether through posts,
            comments, messages, or other communication tools. Trusted Therapist
            Network may limit or remove promotional content that, in its sole
            discretion, conflicts with the purpose of the Services or is
            primarily intended to redirect Members to another paid network or
            community.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Spam and Excessive Promotion
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Trusted Therapist Network may limit or remove Member Content that,
            in its sole discretion, is:
          </p>
          <ul style={{ marginBottom: "0.5rem", paddingLeft: "3.5rem" }}>
            <li style={{ marginBottom: "0.25rem" }}>
              Repetitive or posted excessively;
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              The same as or substantially similar to content recently shared by
              the same Member;
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              Unrelated to the conversation, referral request, or other post
              where it appears;
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              Primarily promotional without contributing meaningful value to the
              community; or
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              Posted primarily to redirect Members away from Trusted Therapist
              Network to another paid platform, network, or community.
            </li>
          </ul>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            You agree that your Member Content will not:
          </p>
          <ul style={{ marginBottom: "0.5rem", paddingLeft: "3.5rem" }}>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem", fontWeight: "900" }}>
                CONTAIN ANY PHI.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Contain any material that is offensive, abusive, defamatory,
                obscene, threatening or harassing.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Promote illegal activity or discrimination based on race, sex,
                religion, nationality, disability, sexual orientation, or age.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Contain any material that infringes or violates the rights of
                any person or entity including, without limitation, intellectual
                property, publicity or privacy rights, or violates applicable
                laws, rules or regulations.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Violate any contractual, legal or ethical obligations to which
                you are subject.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Contain advertising or promotions that are not expressly
                authorized by Trusted Therapist Network in writing.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Misrepresent your current or past affiliation with another
                person or entity, or otherwise contain fraudulent, false,
                deceptive or misleading information.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Misrepresent your current or past professional education,
                professional qualifications, licensure status, or trainee
                status.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Promote, endorse, or solicit business for any third-party vendor, product, or service, including
                practice management, billing, revenue cycle management, credentialing, software, marketing,
                consulting, staffing, or similar offerings, unless expressly authorized by Trusted Therapist
                Network in writing.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Offer, request, advertise, or facilitate any referral fee, commission, kickback, rebate, revenue
                share, affiliate payment, or other compensation tied to the recommendation of any third-party
                vendor, product, or service.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Contain undisclosed endorsements, testimonials, or recommendations for which you or any
                third party receive compensation or other financial benefit.
              </p>
            </li>
          </ul>
          <p style={{ marginBottom: "0.5rem" }}>
            If you believe that any content displayed on the Services violates
            your copyright, refer to the section, "Claims Regarding Copyright
            Infringement" for instructions on sending us a notice of copyright
            infringement.
          </p>
          <p style={{ marginBottom: "2rem" }}>
            While Trusted Therapist Network is not responsible for Member
            Content, it may, but has no obligation to, monitor, review, edit,
            limit, or remove Member Content. In all cases, we reserve the right
            to remove any Member Content for any or no reason, including Member
            Content that we determine in our sole discretion violates these
            Terms or the posting standards described above, threatens the
            personal safety of our Members or the public, interferes with the
            usefulness or intended purpose of the Services, or could create
            liability for Trusted Therapist Network. We may take these actions
            without prior notification to you and shall have no liability as a
            result of any such action.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Use of the Services
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            The Services are intended for use solely by mental health
            practitioners and professionals that refer for mental health and
            substance abuse treatment services. The information made available
            through the Services is provided for informational purposes only and
            is not intended as a substitute for your professional judgment as a
            mental health practitioner or other referring professional. You are
            solely responsible for your decision to use the Services, evaluating
            the information obtained through the Services, and for your decision
            to use such information in connection with your referral and
            treatment decisions and otherwise. Your use of the information
            obtained through the Services is solely at your own risk, and you
            agree that Trusted Therapist Network and its licensors are not
            responsible or liable for any claim, loss, or damage arising from
            your use of such information.
          </p>
          <p style={{ marginBottom: "1rem" }}>
            Trusted Therapist Network is not engaged in the provision of any
            mental health services to any patient. Trusted Therapist Network
            does not recommend or endorse any tests, products, services,
            procedures, opinions, drugs, mental health practitioners and
            professionals that refer for mental health services or substance use
            treatment or other information that may be mentioned in the
            Services, and we assume no responsibility for such information.
          </p>
          <p style={{ marginBottom: "1rem", fontWeight: 900 }}>
            Access to and use of the Services, including any free, discounted,
            or promotional access provided to Members or group practices, is not
            conditioned on any agreement to make, receive, or recommend
            referrals, and no fees paid to Trusted Therapist Network are
            calculated based on the volume or value of referrals or other
            business generated via the Services.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            <b>Fees (Paid Subscriptions Only)</b>
          </p>
          <p style={{ marginBottom: "1rem" }}>
            If you purchase a paid Subscription (and therefore become a Client),
            the following terms apply in addition to the rest of these Terms.
          </p>
          <p style={{ marginBottom: "1rem" }}>
            In connection with Client's use of the Service and pursuant to
            Phoenix Relational's acceptance of the Subscription, Client will pay
            to Phoenix Relational the applicable fees set forth in the
            Subscription. Phoenix Relational reserves the right to increase its
            prices at any time, decrease its prices, charge for previously free
            Services and change its billing.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            <b>Billing Subscriptions (Paid Subscriptions Only)</b>
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            There are three options that may be made available regarding billing subscriptions for Clients:
          </p>
          <ol
            style={{
              listStyleType: "none",
              marginLeft: "2rem",
              marginBottom: "1rem",
            }}
            start={1}
          >
            <li style={{}}>
              (i) Monthly Billing Subscription: A monthly term in which you are
              billed on a monthly basis.
            </li>
            <li style={{}}>
              (ii) Semi-annual Billing Subscription: A six-month term in which
              you are billed once on a semi-annual basis upon the commencement
              of the service.
            </li>
            <li style={{}}>
              (iii) Annual Billing Subscription: A twelve-month term in which
              you are billed once on an annual basis upon the commencement of
              the service.
            </li>
          </ol>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Discounts
          </p>
          <p style={{ marginBottom: "1rem" }}>
            Phoenix Relational may from time to time, in its sole discretion,
            provide special promotions or discounts. If Phoenix Relational
            offers any special promotions or discounts that provide you with
            credits or other incentives in connection with the Service
            ("Promotional Credits"), and you cancel the Service prior to
            completion of the Initial Term (as defined below) (other than for
            cause, as set forth below in Section "Termination for Cause"), you
            will be required to repay to Phoenix Relational the full amount of
            any corresponding discounts.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Manner of Payment
          </p>
          <p style={{ marginBottom: "1rem" }}>
            You will pay for all amounts payable under this Agreement either by
            credit card (the "Client Card"), by electronic debit from your bank
            account ("ACH"), or such other form of payment as Phoenix Relational
            may, in its sole discretion and with prior approval, permit
            (including but not limited to payment by check) or require. You will
            be required to agree to the applicable payment authorization
            form(s), which also permits Phoenix Relational to recover any
            Promotional Credits (as set forth above) in the authorized manner.
            In the case of payment through ACH, no amounts owing are considered
            paid until the electronic debit has been received by Phoenix
            Relational's bank.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Timing of Payment
          </p>
          <p style={{ marginBottom: "1rem" }}>
            Fees, as identified on the Subscription, are due as indicated on the
            Subscription and in accordance with Client's billing subscription
            plan. Phoenix Relational will have the right to charge the Client
            Card or debit from your account through ACH for fees in accordance
            with these Terms. By providing Phoenix Relational with your payment
            information, you agree that Phoenix Relational is authorized, to the
            extent permitted by applicable law, to immediately charge such
            payment method for all fees and charges due and payable to Phoenix
            Relational hereunder and that, except as required by applicable law,
            no additional notice or consent is required. You agree to
            immediately notify Phoenix Relational of any change in the payment
            information used for payment hereunder. You understand and
            acknowledge that all amounts owed must be paid in advance of
            Services. You agree to pay all costs of collection, including
            attorney's fees and costs and all other legal and collection
            expenses incurred by Phoenix Relational in connection with its
            enforcement of its rights under these Terms.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Publicity
          </p>
          <p style={{ marginBottom: "1rem" }}>
            You agree that Phoenix Relational may, during and after the Term of
            this Agreement, include your first name and first letter of your
            last name (including any applicable professional designations, trade
            name, trademark, service mark or logo) on Phoenix Relational's
            client list, and in its marketing materials, online testimonials,
            sales presentations and any online directories that Phoenix
            Relational may, from time to time, publish.
          </p>
          <br />
          <hr />
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Services Availability
          </p>
          <p style={{ marginBottom: "1rem" }}>
            We make reasonable efforts to keep all of the Services fully
            operational, however we may encounter technical difficulties or
            engage in maintenance or updates to the Services that may cause
            temporary interruptions. We reserve the right, at any time, to
            modify, suspend or discontinue any Services or functions and
            features of a Service, without liability to you. You understand and
            agree that Trusted Therapist Network has no obligation to provide
            any specific content through the Services and Trusted Therapist
            Network may, from time to time, remove any content without notice,
            in our sole discretion.
          </p>
          <br />
          <hr />
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Your Trusted Therapist Network Account
          </p>
          <p style={{ marginBottom: "1rem" }}>
            You agree to: (1) choose a strong password, and keep it secure and
            confidential; (2) not permit others to use your login credentials to
            access your Trusted Therapist Network account; and (3) refrain from
            accessing another Trusted Therapist Network member's account. You
            agree you are solely responsible for your account. If you believe
            there has been unauthorized access to your account, you must change
            your username and password and notify us immediately. To close your
            account, please contact us at{" "}
            <a style={{ color: "#93C5FD" }} href="mailto:team@thettn.com">
              team@thettn.com.
            </a>
          </p>
          <br />
          <hr />
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>Privacy</p>
          <p style={{ marginBottom: "1rem" }}>
            The Trusted Therapist Network Privacy Policy explains how we
            collect, use and share personal information in connection with your
            use of the Services. We encourage you to read our Privacy Policy
            carefully because by accessing and using the Services in any way,
            you consent to the handling of your personal information as
            described in the Trusted Therapist Network Privacy Policy. Note that
            we may update our Privacy Policy from time to time, as described
            therein.
          </p>
          <br />
          <hr />
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Third Party Sites
          </p>
          <p style={{ marginBottom: "2rem" }}>
            The Services may include links to third party web sites ("Third
            Party Sites"). You are responsible for evaluating whether you want
            to access or use a Third Party Site, and agree and understand that
            our inclusion of a link to a Third Party Site in no way constitutes
            our affiliation with or endorsement of such site or its content.
            Third Party Sites are governed by their respective terms of service
            and privacy policies, and we encourage you to review the terms and
            policies of any Third Party Site before using it.
          </p>
          <br />
          <hr />
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            COMMUNICATIONS
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Member Communication Tools
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Members may use the Services to communicate information in a variety
            of ways including through their profiles, social actions (e.g.,
            liking, sharing or commenting on an announcement), and through our
            member messaging. We authorize you to use these tools solely for
            non-commercial purposes, unless to promote your practice, services
            or treatment offerings, or as otherwise expressly approved by
            Trusted Therapist Network. You are solely responsible for your
            interactions with other Trusted Therapist Network members. Trusted
            Therapist Network reserves the right, but has no obligation, to
            monitor disputes between you and other members and respond as
            necessary to enforce these Terms.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            A Member's promotion of their own practice, services, treatment
            offerings, events, resources, or other professional opportunities
            through posts and comments is subject to the Member Content
            Standards and posting limitations described in these Terms,
            including the limitation of one self-promotional post within any
            seven-day period.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            For the avoidance of doubt, the communication tools may not be used to market or solicit third-
            party vendor services, to recruit Members into compensated referral or affiliate arrangements,
            or to send vendor promotions, prospecting messages, or other commercial solicitations
            unrelated to the Member's own practice or treatment offerings, unless expressly authorized by
            Trusted Therapist Network in writing.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Members also may not use comments on unrelated Member posts as a
            means of promoting their own services, events, groups, communities,
            or other offerings, or repeatedly contact or solicit Members in a
            manner that Trusted Therapist Network determines is excessive,
            irrelevant, or inconsistent with the intended purpose of the
            Services.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Please note that any information you share through your use of the
            Services (subject to certain privacy settings) will be seen by other
            Trusted Therapist Network members, and may be used and re-shared by
            such members on and outside of Trusted Therapist Network, so be
            mindful as to what you choose to share, and do not share in this
            manner any content or information that is confidential, that you do
            not want others to see or use, or that is subject to referral
            rights.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Trusted Therapist Network IS NOT RESPONSIBLE FOR A MEMBER'S USE,
            MISUSE OR MISAPPROPRIATION OF ANY CONTENT OR INFORMATION YOU POST,
            UPLOAD, OR TRANSMIT VIA THE SERVICES UNLESS OTHERWISE EXPRESSLY
            AGREED BY Trusted Therapist Network PURSUANT TO A SEPARATE WRITTEN
            AGREEMENT.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Communications from Trusted Therapist Network
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            By registering as a Trusted Therapist Network member, you agree to
            receive communications from Trusted Therapist Network related to the
            Services based on the contact information you provide us, including
            through our messaging tools and e-mail. You acknowledge and agree
            that we shall have no liability associated with or arising from your
            failure to maintain accurate contact or other information,
            including, but not limited to, your failure to receive critical
            information about the Services. You may opt-out of receiving certain
            communications from Trusted Therapist Network as described in our
            Privacy Policy.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            OWNERSHIP AND LICENSES
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Proprietary Rights
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            The Services, including our websites, mobile apps and their content,
            features and functionality (including, but not limited to, all
            information, software, text, displays, images, video, and audio, and
            the design, selection, and arrangement thereof) are owned by Trusted
            Therapist Network, its licensors, or other providers of such
            materials, and are protected by United States and international
            copyright, trademark, patent, trade secret, and other intellectual
            property or proprietary rights laws. The name Trusted Therapist
            Network, the Trusted Therapist Network logo and other Trusted
            Therapist Network logos and product and service names are the
            exclusive trademarks of, and are owned by, Trusted Therapist
            Network, and you may not use or display such trademarks in any
            manner without Trusted Therapist Network's prior written permission.
            Any third-party trademarks or service marks displayed on the
            Services are the property of their respective owners. Your use of
            the Services grants you no right to reproduce, license or otherwise
            use any such trademarks, logos or other proprietary marks.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            License to Use the Services
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Subject to these Terms, we grant you a limited, revocable,
            non-exclusive, non-assignable, non-sublicensable license to access
            the Services for your personal, non-commercial use, unless otherwise
            agreed by Trusted Therapist Network, and only as permitted by the
            features of the Services. Any other use of the Services is strictly
            prohibited and a violation of these Terms. We reserve all rights not
            expressly granted in these Terms, including, without limitation,
            title, ownership, intellectual property rights in the Services,
            including any content made available through the Services, and our
            consent to your use of the Services does not impair those rights in
            any way. For the avoidance of doubt, you are not granted a right to
            re-use or re-publish any content made available through the Services
            including, without limitation, Member Content submitted by other
            members, without the express written permission of Trusted Therapist
            Network or such member, as applicable.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Your License to Trusted Therapist Network
          </p>
          <p style={{ marginBottom: "2rem" }}>
            Unless otherwise agreed by you and Trusted Therapist Network, any
            original content you submit to Trusted Therapist Network remains
            your property, and you may choose to make it available to others. By
            posting, uploading or otherwise submitting content and other
            information to the Services, you grant Trusted Therapist Network a
            nonexclusive, irrevocable, worldwide, perpetual, unlimited,
            assignable, sublicensable, royalty-free, fully-paid up license to
            copy, prepare derivative works from, improve, distribute, publish,
            remove, retain, add, process, analyze, index, tag, use and
            commercialize such content and other information in any media, form
            or format now known or hereafter developed, in any manner that is
            consistent with the Trusted Therapist Network Privacy Policy and
            applicable law. By submitting ideas, suggestions, or other feedback
            to Trusted Therapist Network, you agree that we can use, share and
            commercialize such feedback for any purpose without restriction and
            without any obligation to make any compensation to you.
          </p>
          <hr />
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            TERM AND TERMINATION
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Community Moderation
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Trusted Therapist Network may remove posts or comments that do not
            comply with these Terms or otherwise do not align with the intended
            purpose of the Services. When Trusted Therapist Network determines it
            is appropriate under the circumstances, a Member may receive a
            reminder or warning regarding these Terms before additional action
            is taken. Trusted Therapist Network is not required to provide a
            warning before removing content or taking other action.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Repeated violations, or conduct that Trusted Therapist Network
            determines warrants immediate action, may result in temporary
            posting or messaging restrictions, suspension of access to some or
            all features of the Services, or termination of the Member's account
            or platform access. Trusted Therapist Network retains sole discretion
            in determining whether Member Content or conduct violates these Terms
            and what moderation or enforcement action, if any, is appropriate.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>Term</p>
          <p style={{ marginBottom: "0.5rem" }}>
            For Clients with a paid Subscription, this Agreement will continue
            for the period indicated on the applicable Subscription (the
            "Initial Term").
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Auto-Renewal
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Provided that Client has paid all fees due under this Agreement,
            this Agreement will automatically renew for successive periods
            matching that of the initial Subscription ("Renewal Term(s)") unless
            either party provides notice of non-renewal in accordance with
            subsection "Notice of Non-Renewal" below. The Initial Term and any
            subsequent Renewal Term(s) may be collectively referred to as the
            "Term".
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: 900 }}>
            In addition, regardless of whether you have a paid Subscription, we
            may suspend or terminate your account or access to some or all of
            the Services at any time, with or without cause, and with or without
            notice, to the extent permitted by applicable law. Without limiting the foregoing, Trusted Therapist Network may, in its sole discretion and with or without notice, immediately deny access to, suspend, restrict, or terminate any account based on any past, present, or pending disciplinary action or proceeding, licensure-related issue, regulatory concern, ethical complaint, exclusion, or other professional conduct concern, whether or not such matter results in final agency or board action.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Notice of Non-Renewal
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            To prevent renewal of a subscription, you must cancel your
            membership on the "Subscriptions" page of the website before the
            current Term renews. Alternatively, you or we must give written
            notice of non-renewal and this written notice must be received no
            more than fourteen (14) days but no less than one (1) day in advance
            of the end of the subscription then in effect. If you decide not to
            renew by written notice, you must send the notice of non-renewal by
            email to{" "}
            <a style={{ color: "#93C5FD" }} href="mailto:team@thettn.com">
              team@thettn.com.
            </a>{" "}
            Any notice received with less than 1 days' notice may result in
            auto-renewal of your subscription for an additional Renewal Term.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            We reserve the right to monitor your use of the Services and to
            suspend or terminate your use of the Services without notice if we
            determine that you have breached these Terms. In no event will
            Trusted Therapist Network be liable for suspension or termination of
            your use of any of the Services.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Without limiting the foregoing, we may remove vendor-promotional content, restrict messaging
            privileges, suspend or terminate accounts, and report conduct to appropriate parties where we
            believe a Member has used the Services for unauthorized commercial solicitation, fee-splitting,
            kickbacks, or other prohibited vendor-related activity.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Without limiting the foregoing, Trusted Therapist Network may remove
            Member Content, restrict posting or messaging privileges, temporarily
            suspend access to certain features, or suspend or terminate accounts
            where we determine that a Member has repeatedly violated the Member
            Content Standards, engaged in spam or excessive promotion, used
            unrelated posts for promotional purposes, or used the Services
            primarily to redirect Members to an outside paid network or
            community.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            No Early Termination; No Refunds
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            The subscription term in effect will end on the expiration date and
            you cannot cancel it until 14 days before its expiration. We do not
            provide refunds if you decide to stop using the subscription during
            your subscription term.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Suspension for Non-Payment
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            We will provide you with notice of non-payment of any amount due.
            Unless the full amount has been paid, we may suspend your access to
            any portion or all of the Service ten (10) days after such notice.
            We will not suspend the Service while you are disputing the
            applicable charges reasonably and in good faith and are cooperating
            diligently to resolve the dispute. If your Service is suspended for
            non-payment, we may charge a re-activation fee to reinstate the
            Service.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Termination for Cause
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Either party will have the right to terminate this Agreement if the
            other party breaches any material term or condition of this
            Agreement and fails to cure such breach within thirty (30) days
            after receipt of written notice of the same, except in the case of
            Client's failure to pay fees, which must be cured within ten (10)
            days after receipt of written notice from Phoenix Relational.
            Pursuant to the payment policies outlined in "Fees", you understand
            and agree that you will not be entitled to any refunds of amounts
            already paid to Phoenix Relational unless you properly terminate the
            Agreement for cause per the terms of this Section.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Effect of Termination
          </p>
          <p style={{ marginBottom: "2rem" }}>
            Upon the expiration or termination of this Agreement, Client's
            rights to access and use the Service will terminate, provided that:
            (i) any and all payment obligations of Client under this Agreement
            outstanding as of the effective date of expiration or termination
            will survive; and (ii) all sections of these Terms that by their
            nature should survive termination shall survive termination,
            including without limitation, Privacy, Ownership and Licenses,
            Disclaimers and Limitation of Liability, Indemnity, Choice of Law;
            Dispute Resolution, and Additional Terms.
          </p>
          <hr />
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            DISCLAIMERS AND LIMITATION OF LIABILITY
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Warranty Disclaimer
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            WE MAKE NO REPRESENTATION OR WARRANTY ABOUT THE SERVICES, INCLUDING
            THAT THEY WILL BE UNINTERRUPTED OR ERROR-FREE, OR THAT INFORMATION
            YOU OBTAIN THROUGH THE SERVICES IS ACCURATE OR COMPLETE. THE
            SERVICES AND ALL CONTENT, INFORMATION (INCLUDING, WITHOUT
            LIMITATION, MEMBER PROFILE INFORMATION), TOOLS AND FEATURES MADE
            AVAILABLE THROUGH THE SERVICES, ARE PROVIDED ON AN "AS-IS" AND
            "AS-AVAILABLE" BASIS. TO THE FULLEST EXTENT PERMISSIBLE UNDER
            APPLICABLE LAW, WE AND OUR AFFILIATES DISCLAIM ANY AND ALL IMPLIED
            OR STATUTORY WARRANTIES OF ANY KIND, INCLUDING WITHOUT LIMITATION
            IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE, ACCURACY, TITLE, AND NON-INFRINGEMENT.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            IF YOU ARE DISSATISFIED WITH THE SERVICES, YOU AGREE THAT YOUR SOLE
            AND EXCLUSIVE REMEDY IS TO TERMINATE YOUR Trusted Therapist Network
            ACCOUNT.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Limitation of Liability
          </p>
          <p style={{ marginBottom: "2rem" }}>
            TO THE FULLEST EXTENT PERMITTED BY LAW, (I) IN NO EVENT WILL Trusted
            Therapist Network, ITS AFFILIATES, OR THEIR RESPECTIVE LICENSORS,
            SERVICE PROVIDERS, EMPLOYEES, AGENTS, OFFICERS, DIRECTORS, OR
            SHAREHOLDERS BE LIABLE FOR ANY INDIRECT, CONSEQUENTIAL, SPECIAL,
            INCIDENTAL, OR PUNITIVE DAMAGES (INCLUDING DAMAGES FOR LOSS OF
            PROFITS, BUSINESS OPPORTUNITIES, OR GOODWILL, OR ANY OTHER
            INTANGIBLE LOSS) ARISING OUT OF, BASED ON, OR RESULTING FROM THESE
            TERMS OR YOUR USE OR ACCESS, OR INABILITY TO USE OR ACCESS, THE
            SERVICE OR ANY COMPONENT THEREOF, WHETHER BASED ON BREACH OF
            CONTRACT, BREACH OF WARRANTY, NEGLIGENCE, OR ANY OTHER CAUSE OF
            ACTION, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES; (II)
            Trusted Therapist Network'S AGGREGATE LIABILITY FOR ALL CLAIMS,
            ACTIONS AND/OR OMISSIONS ARISING FROM OR RELATED TO THE SERVICES AND
            THE SUBJECT MATTER OF THESE TERMS SHALL NOT EXCEED THE AMOUNTS
            ACTUALLY PAID BY YOU DURING THE THREE (3) MONTHS IMMEDIATELY
            PRECEDING YOUR INITIAL CLAIM; AND (III) Trusted Therapist Network
            AND ITS AFFILIATES ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY
            ERRORS, MISTAKES, OR INACCURACIES OF MATERIALS MADE AVAILABLE
            THROUGH THE SERVICES OR AS A RESULT OF THE USE OF ANY SUCH
            MATERIALS, PERSONAL INJURY OF ANY NATURE WHATSOEVER RESULTING FROM A
            MEMBER'S ACCESS TO OR USE OF THE SERVICES, OR ANY UNAUTHORIZED
            ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL
            INFORMATION STORED THEREIN. EACH PROVISION OF THESE TERMS THAT
            PROVIDES FOR A LIMITATION OF LIABILITY, DISCLAIMER OF WARRANTIES, OR
            EXCLUSION OF DAMAGES IS INTENDED TO AND DOES ALLOCATE THE RISKS
            BETWEEN YOU AND Trusted Therapist Network UNDER THESE TERMS. THIS
            ALLOCATION IS AN ESSENTIAL ELEMENT OF OUR AGREEMENT, AND THE
            LIMITATIONS IN THIS SECTION WILL APPLY EVEN IF ANY LIMITED REMEDY
            FAILS ITS ESSENTIAL PURPOSE.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            CLAIMS REGARDING COPYRIGHT INFRINGEMENT
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            The Digital Millennium Copyright Act (the "DMCA") provides recourse
            for copyright owners who believe that material appearing on the
            internet infringes their rights under U.S. copyright law. If you
            believe in good faith that materials hosted by Trusted Therapist
            Network infringe your copyright or trademark rights, you (or your
            agent) may send us a notice requesting that the material be removed,
            or access to it blocked. The notice must include the following
            information:
          </p>
          <ul style={{ marginBottom: "0.5rem", paddingLeft: "3.5rem" }}>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Identification of the copyrighted work that you believe to be
                infringed. Please describe the work, and where possible include
                a copy or the location (e.g., URL) of an authorized version of
                the work.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Identification of the material that you believe to be infringing
                and its location. Please describe the material, and provide us
                with its URL or any other pertinent information that will allow
                us to locate the material.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                Your name, address, telephone number and (if available) e-mail
                address.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                A statement that you have a good faith belief that the
                complained of use of the materials is not authorized by the
                copyright owner, its agent, or the law.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                A statement that the information that you have supplied is
                accurate, and indicating that "under penalty of perjury," you
                are the copyright owner or are authorized to act on the
                copyright owner's behalf.
              </p>
            </li>
            <li style={{ marginBottom: "0.25rem" }}>
              <p style={{ marginBottom: "0.5rem" }}>
                A physical or electronic signature of a person authorized to act
                on behalf of the owner of an exclusive right that is allegedly
                infringed.
              </p>
            </li>
          </ul>
          <p style={{ marginBottom: "0.5rem" }}>
            Please be advised that Trusted Therapist Network will not respond to
            complaints that do not meet these requirements. If Trusted Therapist
            Network determines the materials alleged to infringe your copyright
            or trademark rights do not require removal, Trusted Therapist
            Network will remove those materials only pursuant to a court order
            declaring the content or use of the materials unlawful.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            If you believe in good faith that a notice of copyright infringement
            has been wrongly filed against you, the DMCA permits you to send us
            a counter-notice. Counter-notices must include the following
            information: (a) your name, address, and telephone number; (b) the
            source of the content that was removed; (c) a statement under
            penalty of perjury that you have a good-faith belief that the
            content was removed in error; (d) a statement that you consent to
            the jurisdiction of Federal District Court for the judicial district
            in which your address is located or, if your address is outside of
            the United States, for any judicial district in which Trusted
            Therapist Network may be found, and that you will accept service of
            process from the person who provided the original complaint; and (e)
            a physical or electronic signature (for example, typing your full
            name).
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Agent to Receive Notices of Claimed Infringement:
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Phoenix Relational LLC d/b/a Trusted Therapist Network
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            C/O Legal Dept. 22311 South Woodland Road
          </p>
          <p style={{ marginBottom: "0.5rem" }}>Shaker Heights, OH 44122</p>
          <br />
          <hr />
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            INDEMNITY
          </p>
          <p style={{ marginBottom: "1rem" }}>
            You agree to indemnify and hold harmless Trusted Therapist Network,
            its affiliates, officers, agents, employees, and licensors from and
            against any claims, liabilities, damages, judgments, awards, losses,
            costs, expenses, or fees (including reasonable attorneys' fees)
            arising out of or relating to (1) your failure to comply with these
            Terms, (2) your Member Content, and (3) your use of the Services.
          </p>
          <br />
          <hr />
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            CHOICE OF LAW; DISPUTE RESOLUTION
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            These Terms and the Services, as well as all related disputes, are
            governed by the laws of the State of Ohio, without giving effect to
            its conflict of law provisions, regardless of from where you access
            the Services. You agree that the exclusive place of jurisdiction for
            all disputes or claim relating to the Services and/or these Terms is
            Cleveland, Ohio, or the United States District Court for Cuyahoga
            County, Ohio, except as otherwise agreed by the parties or as
            described in the Arbitration Agreement, below.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: 900 }}>
            Please read this section carefully, as it affects your legal rights,
            including your right to file a lawsuit in court.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            The purpose of this section is to describe what will happen if you
            and Trusted Therapist Network have a dispute that needs to be
            resolved. If you have an issue with the Services, we encourage you
            to contact Trusted Therapist Network Member Support at team@thettn.com.
            If your issue is not resolved by Member Support, you agree that you
            and Trusted Therapist Network will first discuss the issue
            informally for at least 60 days before commencing an arbitration
            action, as described in the arbitration agreement below (the
            "Arbitration Agreement"). To initiate a discussion, please send your
            full name and contact information to us at Phoenix Relational LLC
            d/b/a Trusted Therapist Network, Attn: Legal Department, 22311 South
            Woodland Road, Shaker Heights, Ohio, 44122, and if we need to
            contact you we will use the e-mail address associated with your
            Trusted Therapist Network account. If we are unable to resolve the
            issue within 60 days, you and Trusted Therapist Network agree that
            any and all claims that either of us have, whether based on past,
            present or future events arising out of or relating to these Terms
            (including the scope and enforceability of this Arbitration
            Agreement), the Services, and any aspect of our relationship with
            each other, except for disputes relating to Trusted Therapist
            Network's intellectual property (such as trademarks, domain names,
            trade secrets, copyrights, and patents), must be resolved through
            binding arbitration. Arbitration is more informal than a lawsuit in
            court. Arbitration uses a neutral arbitrator instead of a judge or
            jury, allows for more limited discovery than in court, and is
            subject to very limited review by courts. Arbitrators can award the
            same damages and relief that a court can award. Nothing in this
            Arbitration Agreement shall be interpreted as limiting any
            non-waivable statutory rights. You agree that, by agreeing to these
            Terms, the U.S. Federal Arbitration Act ("FAA") governs the
            interpretation and enforcement of this Arbitration Agreement.
            Arbitration will be administered by JAMS Mediation, Arbitration, and
            ADR Services ("JAMS") in accordance with its provisions and
            procedures for consumer-related disputes, excluding any rules or
            procedures governing or permitting class actions. Instructions about
            how to initiate an arbitration and information about the JAMS
            Streamlined Arbitration Rules and Procedures ("JAMS Rules") are
            available at www.jamsadr.com or 1-800-352-5267. No arbitration or
            proceeding can be combined with another without the prior written
            consent of you, Trusted Therapist Network, and any other parties to
            the arbitration or proceedings.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            PLEASE BE AWARE THAT YOU ARE GIVING UP THE RIGHT TO LITIGATE A
            DISPUTE IN COURT BEFORE A JUDGE OR JURY. YOU AND Trusted Therapist
            Network AGREE TO ARBITRATE IN EACH OF OUR INDIVIDUAL CAPACITIES
            ONLY, NOT AS A REPRESENTATIVE OR MEMBER OF A CLASS, AND EACH OF US
            EXPRESSLY WAIVES ANY RIGHT TO FILE A CLASS ACTION OR SEEK RELIEF ON
            A CLASS BASIS.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Notwithstanding the foregoing, you and Trusted Therapist Network
            agree that nothing herein will be deemed to waive, preclude, or
            otherwise limit either of our rights, at any time, to (1) bring an
            individual action in a U.S. "small claims" court, but only if your
            claim qualifies, your claim remains in such court, and your claim
            remains on an individual, non-representative, and non-class basis,
            or (2) bring an individual action seeking only temporary or
            preliminary individualized injunctive relief in a court of law,
            pending a final ruling from the arbitrator.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            For your convenience, arbitration may be conducted in-person,
            through the submission of documents, by phone, or online.
            Proceedings that cannot be conducted through the submission of
            documents, by phone, or online, will take place in Cleveland, Ohio.
            It is important that you understand that the arbitrator's decision
            will be binding and final (except for a limited right of appeal
            under the FAA) and may be entered as a judgment in any court of
            competent jurisdiction. Please note that nothing in this section
            shall be construed as consent by Trusted Therapist Network to the
            jurisdiction of any other court with respect to disputes not covered
            by these Terms.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            In accordance with the JAMS Rules, the party initiating the
            arbitration (either you or Trusted Therapist Network) is responsible
            for paying the filing fee. However, if the arbitrator issues you an
            award of damages and (i) that award is greater than the amount of
            our last written settlement offer, or (ii) if we did not make a
            settlement offer, then in addition to paying for any JAMS Case
            Management Fees and all professional fees for the arbitrator's
            services, we will reimburse you the filing fees you incurred.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            You have the right to opt out and not be bound by this Arbitration
            Agreement and class-action-waiver set forth in this section by
            sending written notice of your decision to opt out to the following
            address: Phoenix Relational LLC d/b/a Trusted Therapist Network,
            Attn: Legal Department, 22311 South Woodland Road, Shaker Heights,
            Ohio, 44122. The notice must be sent within 30 days of after first
            becoming subject to a version of these Terms containing the
            Arbitration Agreement and waiver; otherwise, you shall be bound to
            arbitrate disputes in accordance with these Terms. If you opt out of
            arbitration, all other parts of these Terms will continue to apply
            to you.
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            If any portion of this Arbitration Agreement is found to be
            unenforceable or unlawful for any reason, (1) the unenforceable or
            unlawful provision shall be severed from these Terms; (2) severance
            of the unenforceable or unlawful provision shall have no impact
            whatsoever on the remainder of the Arbitration Agreement or the
            parties' ability to compel arbitration of any remaining claims on an
            individual basis pursuant to the Arbitration Agreement; and (3) to
            the extent that any claims must therefore proceed on a class,
            collective, consolidated, or representative basis, such claims must
            be litigated in a civil court of competent jurisdiction and not in
            arbitration, and the parties agree that litigation of those claims
            shall be stayed pending the outcome of any individual claims in
            arbitration.
          </p>
          <p style={{ marginBottom: "2rem" }}>
            In the interest of promptly resolving issues between us, you and
            Trusted Therapist Network agree to bring any claim arising out of or
            relating to these Terms, any policy governing your use of the
            Services, our relationship, or the use of the Services within one
            year after a claim arises, otherwise, the claim is waived. This
            limitation applies regardless of the venue in which such claim is or
            could otherwise be asserted.
          </p>
          <br />
          <hr />
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            ADDITIONAL TERMS
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Severability
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            If any provision of these Terms is found by a court of competent
            jurisdiction or arbitrator to be illegal, void, or unenforceable,
            the unenforceable provision will be modified so as to render these
            Terms enforceable and effective to the maximum extent possible in
            order to effect the intention of the provision; and if a court or
            arbitrator finds the modified provision invalid, illegal, void or
            unenforceable, the validity, legality and enforceability of the
            remaining provisions of these Terms will not be affected in any way.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            No Waiver
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            Failure to enforce any part of these Terms is not a waiver of the
            right to later enforce that or any other part of these Terms.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Relationship of the Parties
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            You agree that no joint venture, partnership, joint controllership,
            employment or agency relationship exists between you and Trusted
            Therapist Network as a result of these Terms or your use of the
            Services.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>Notice</p>
          <p style={{ marginBottom: "0.5rem" }}>
            Trusted Therapist Network's notice to you via e-mail, regular mail
            or notices, posts, or links on the Services shall constitute
            acceptable notice to you under these Terms. You must provide any
            notice to us in writing and send via certified courier or via e-mail
            with a confirmation of receipt.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Assignment
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            You may not assign, delegate or otherwise transfer your account or
            your obligations under these Terms without the prior written consent
            of Trusted Therapist Network. Trusted Therapist Network has the
            right, in its sole discretion, to transfer or assign all or any part
            of its rights under these Terms and will have the right to delegate
            or use third parties to fulfill its duties and obligations under
            these Terms and in connection with the Services.
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Changes to these Terms
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            We reserve the right to modify these Terms and any policies
            applicable to your use of the Services at any time in our sole
            discretion. When we make a change, we will post the updated Terms
            with a new "Effective Date," and we will maintain a record of each
            version and of how and when Members were notified. We may, and if
            required by law, will also provide notification of changes in
            another way that we believe is reasonably likely to reach you, such
            as by e-mail (if you have an account where we have your contact
            information) or another manner through the Services. For material
            changes, we may require you to affirmatively accept the updated
            Terms (for example, by clicking "I Agree") before continuing to
            access the Services. Any modifications to these Terms will be
            effective upon posting or as otherwise indicated at the time of
            posting. In all cases, by continuing to use the Services after
            posting of the updated Terms, you are consenting to the changes. If
            you object to any changes, you may close your account by contacting{" "}
            <a style={{ color: "#93C5FD" }} href="mailto:team@thettn.com">
              team@thettn.com
            </a>
            .
          </p>
          <p style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            Entire Agreement
          </p>
          <p style={{ marginBottom: "0.5rem" }}>
            These Terms and the Privacy Policy constitute the entire, complete
            and exclusive agreement between you and us regarding your use of the
            Services and supersede all prior agreements and understandings,
            whether written or oral, or whether established by custom, practice,
            policy or precedent, with respect to the subject matter of these
            Terms. If any provision of these Terms is found by a court of
            competent jurisdiction to be invalid, the parties nevertheless agree
            that the court should endeavor to give effect to the parties'
            intentions as reflected in the provision, and the other provisions
            of these Terms remain in full force and effect.
          </p>
        </div>
      </section>
    </main>
  );
};

export default Terms;
